// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"fd3654bd","925":"fd3654bd"}[chunkId] + ".chunk.css";
};